import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonNote,
  IonButtons,
  IonButton,
  IonIcon,
  useIonToast,
  useIonActionSheet,
  IonText,
  IonItem,
  IonReorderGroup,
  IonReorder,
} from "@ionic/react";
import { ItemReorderEventDetail } from "@ionic/core";
import { trash, document, close, repeat } from "ionicons/icons";
import { useRecoilState } from "recoil";
import { doCopy, setLocalStorage } from "../helper";
import { historyStore } from "../store";
import "./Tab2.css";
import { useState } from "react";

const Tab2: React.FC = () => {
  const [history, setHistory] = useRecoilState<string[]>(historyStore);
  const [presentToast, dismiss] = useIonToast();
  const [presentAction, dismissAction] = useIonActionSheet();
  const [isReorder, setIsReorder] = useState(true);
  const deletedHandler = (i: number) => {
    presentAction({
      header: "削除しますか？",
      buttons: [
        { text: "消去", handler: () => doDelete(i), icon: trash },
        { text: "キャンセル", icon: close },
      ],
    });
  };
  const allDeleteHandle = () => {
    presentAction({
      header: '"全て"消去しますか？',
      buttons: [
        { text: "全て消去", handler: () => doAllDelete(), icon: trash },
        { text: "キャンセル", icon: close },
      ],
    });
  };

  const doDelete = (i: number) => {
    let tmp = history.slice();
    tmp.splice(i, 1);
    setHistory(tmp);
    presentToast({
      buttons: [{ text: "OK", handler: () => dismiss() }],
      message: "消去しました。",
      duration: 1000,
      color: "dark",
      position: "middle",
    });
    setLocalStorage("history", []);
  };
  const doAllDelete = () => {
    setHistory([]);
    presentToast({
      buttons: [{ text: "OK", handler: () => dismiss() }],
      message: "消去しました。",
      duration: 1000,
      color: "dark",
      position: "middle",
    });
    setLocalStorage("history", []);
  };
  const copyHandle = (i: number) => {
    doCopy(history[i]);
    presentToast({
      buttons: [{ text: "OK", handler: () => dismiss() }],
      message: "コピーしました",
      duration: 1000,
      color: "dark",
      position: "middle",
    });
  };
  const doReorder = (event: CustomEvent<ItemReorderEventDetail>) => {
    let items = history.slice();
    items = event.detail.complete(items);
    setHistory(items);
    setLocalStorage("history", items);
  };
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          {/* <IonTitle>保存履歴</IonTitle> */}
          {history.length !== 0 && (
            <IonButtons slot="end">
              <IonButton
                color={isReorder ? "medium" : "primary"}
                onClick={() => setIsReorder(!isReorder)}
              >
                <IonIcon icon={repeat} />
                並び替え
              </IonButton>
              <IonButton color="danger" onClick={() => allDeleteHandle()}>
                <IonIcon icon={trash} />
                全部消去
              </IonButton>
            </IonButtons>
          )}
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div>
          {history.length === 0 ? (
            <IonText>変換後、保存すると履歴が表示されます。</IonText>
          ) : (
            <IonText>コピーするときは並び替えをOFFにしてください。</IonText>
          )}
        </div>
        <IonReorderGroup onIonItemReorder={doReorder} disabled={isReorder}>
          {history.map((aa: string, index: number) => (
            <IonReorder key={aa}>
              <IonNote>{index + 1}</IonNote>
              <IonItem>
                <IonText style={{ whiteSpace: "pre" }}>{aa}</IonText>
                <IonButtons className="function-buttons-bottom">
                  <IonButton onClick={() => copyHandle(index)}>
                    <IonIcon icon={document} />
                    コピー
                  </IonButton>
                  <IonButton
                    color="danger"
                    onClick={() => deletedHandler(index)}
                  >
                    <IonIcon icon={trash} />
                    消去
                  </IonButton>
                </IonButtons>
              </IonItem>
            </IonReorder>
          ))}
        </IonReorderGroup>
      </IonContent>
    </IonPage>
  );
};

export default Tab2;
